import { TweenLite } from 'gsap';
import * as THREE from 'three';
import imagesLoaded from 'imagesloaded';

//
var script$1 = {
  name: "Contentgrid",
  // vue component name
  props: {
    //接受的数据
    dataArray: {
      type: Array
    },
    //是否显示loading
    loading: {
      type: Boolean,
      default: true
    },
    //是否显示右侧按钮
    pagination: {
      type: Boolean,
      default: true
    },
    //是否开启鼠标滚轮事件
    wheelEvents: {
      type: Boolean,
      default: true
    },
    //动画强度
    intensity: {
      type: Number,
      default: 0.4
    }
  },
  // 使用watch监听
  watch: {
    dataArray: {
      immediate: true,
      deep: true,
      handler(newvalue, oldvalue) {
        //this.headobj =newvalue;不做拷贝不行接受的是地址值
        this.datatext = JSON.parse(JSON.stringify(newvalue));
      }
    },
    wheelEvents: {
      immediate: true,
      handler(newvalue, oldvalue) {
        this.$nextTick(() => {
          newvalue ? this.addWheelEvents() : "";
        });
      }
    }
  },
  data() {
    return {
      render: {
        renderW: 0,
        renderH: 0
      },
      canvasProperty: {
        canvasWidth: 0,
        canvasHeight: 0
      },
      //滚动位移参数
      startY: 0,
      //three属性
      renderer: null,
      scene: null,
      camera: null,
      mat: null,
      //指示当前展示的索引
      curIdx: 0,
      //loading锁
      loadingLook: true,
      //渲染锁
      AnimatingLook: false,
      //渲染的图片组
      sliderImages: [],
      htmlText: {
        TitleName: "远东豹",
        StatusName: "极度濒危"
      }
    };
  },
  methods: {
    init() {
      imagesLoaded(document.querySelectorAll("img"), () => {
        this.loadingLook = false;
        const el = this.$refs.slider;
        const imgs = Array.from(el.querySelectorAll("img"));
        this.displacementSlider({
          parent: el,
          images: imgs
        });
        this.animate();
        this.resize();
      });
    },
    /**
     * @description: 动画渲染
     * @return {*}
     */
    animate() {
      requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
    },
    /**
     * @description: 主方法
     * @param {*} opts
     * @return {*}
     */
    displacementSlider(opts) {
      // 顶点着色器代码
      let vertex = `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
`;
      // 片段着色器代码
      let fragment = `
    
    varying vec2 vUv;

    uniform sampler2D currentImage;
    uniform sampler2D nextImage;

    uniform float dispFactor;

    void main() {

        vec2 uv = vUv;
        vec4 _currentImage;
        vec4 _nextImage;
        float intensity = ${this.$props.intensity};

        vec4 orig1 = texture2D(currentImage, uv);
        vec4 orig2 = texture2D(nextImage, uv);
        // 当前图片的偏移
        _currentImage = texture2D(currentImage, vec2(uv.x, uv.y + dispFactor * (orig2 * intensity)));
        // 下一张图片的偏移
        _nextImage = texture2D(nextImage, vec2(uv.x, uv.y + (1.0 - dispFactor) * (orig1 * intensity)));
        // 混合两张图片
         vec4 finalTexture = mix(_currentImage, _nextImage, dispFactor);

        //黑白照片效果
        // vec4 finalTexture = mix(_currentImage, _nextImage, dispFactor);
        // float gray = dot(finalTexture.rgb, vec3(0.299, 0.587, 0.114));
        // finalTexture.rgb = vec3(gray);


        gl_FragColor = finalTexture;

    }
`;
      let images = opts.images,
        image;
      this.canvasProperty.canvasWidth = images[0].clientWidth;
      this.canvasProperty.canvasHeight = images[0].clientHeight;
      let parent = opts.parent;
      let renderWidth = parent.offsetWidth;
      let renderHeight = parent.offsetHeight;

      // 按照1:1.2的比例计算宽高
      let aspectRatio = 1.2;
      let minDimension = Math.min(renderWidth, renderHeight);
      let maxDimension = Math.max(renderWidth, renderHeight);
      if (maxDimension === renderWidth) {
        this.render.renderW = minDimension * aspectRatio;
        this.render.renderH = minDimension;
      } else {
        this.render.renderH = minDimension * aspectRatio;
        this.render.renderW = minDimension;
      }
      // 创建 WebGL 渲染器
      let renderer = new THREE.WebGLRenderer({
        antialias: false
      });
      // 设置像素比率

      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setClearColor(0x23272a, 1.0);
      renderer.setSize(this.render.renderW, this.render.renderH);
      parent.appendChild(renderer.domElement);
      // 创建纹理加载器
      let loader = new THREE.TextureLoader();
      loader.crossOrigin = "anonymous";
      //遍历图片列表，将其添加到sliderImages数组中
      images.forEach(img => {
        image = loader.load(img.getAttribute("src") + "?v=" + Date.now());
        image.magFilter = image.minFilter = THREE.LinearFilter;
        image.anisotropy = renderer.capabilities.getMaxAnisotropy();
        this.sliderImages.push(image);
      });
      // 创建场景、相机、材质和几何体，并添加到场景中
      let scene = new THREE.Scene();
      scene.background = new THREE.Color(0x23272a);
      let camera = new THREE.OrthographicCamera(renderWidth / -2, renderWidth / 2, renderHeight / 2, renderHeight / -2, 1, 1000);
      camera.position.z = 1;
      let mat = new THREE.ShaderMaterial({
        uniforms: {
          dispFactor: {
            type: "f",
            value: 0.0
          },
          currentImage: {
            type: "t",
            value: this.sliderImages[0]
          },
          nextImage: {
            type: "t",
            value: this.sliderImages[1]
          }
        },
        vertexShader: vertex,
        fragmentShader: fragment,
        transparent: true,
        opacity: 1.0
      });
      let geometry = new THREE.PlaneBufferGeometry(parent.offsetWidth, parent.offsetHeight, 1);
      let object = new THREE.Mesh(geometry, mat);
      object.position.set(0, 0, 0);
      scene.add(object);
      this.camera = camera;
      this.renderer = renderer;
      this.mat = mat;
      this.scene = scene;
    },
    /**
     * @description: 视窗大小改变时，重新设置渲染器的大小
     * @return {*}
     */
    resize() {
      window.addEventListener("resize", e => {
        let parent = this.$refs.slider;
        let renderWidth = parent.offsetWidth;
        let renderHeight = parent.offsetHeight;

        // 按照1:1.2的比例计算宽高
        let aspectRatio = 1.2;
        let minDimension = Math.min(renderWidth, renderHeight);
        let maxDimension = Math.max(renderWidth, renderHeight);
        if (maxDimension === renderWidth) {
          this.render.renderW = minDimension * aspectRatio;
          this.render.renderH = minDimension;
        } else {
          this.render.renderH = minDimension * aspectRatio;
          this.render.renderW = minDimension;
        }
        this.renderer.setSize(this.render.renderW, this.render.renderH);
      });
    },
    TweenLiteAnimation() {
      //动画切换时执行的回调函数
      this.$emit("change", this.curIdx);
      TweenLite.to(this.mat.uniforms.dispFactor, 1, {
        value: 1,
        ease: "Expo.easeInOut",
        onComplete: () => {
          this.mat.uniforms.currentImage.value = this.sliderImages[this.curIdx];
          this.mat.uniforms.currentImage.needsUpdate = true;
          this.mat.uniforms.dispFactor.value = 0.0;
          this.AnimatingLook = false;
        }
      });
      //给按钮生成动画
      let slideTitleEl = this.$parent.$refs.slidetitle;
      let slideStatusEl = this.$parent.$refs.slidestatus;
      const nextItem = this.datatext[this.curIdx];
      if (slideTitleEl) {
        let nextSlideTitle = nextItem.TitleName;
        TweenLite.fromTo(slideTitleEl, 0.5, {
          autoAlpha: 1,
          y: 0
        }, {
          autoAlpha: 0,
          y: 20,
          ease: "Expo.easeIn",
          onComplete: () => {
            this.htmlText.TitleName = nextSlideTitle;
            TweenLite.to(slideTitleEl, 0.5, {
              autoAlpha: 1,
              y: 0
            });
          }
        });
      }
      if (slideStatusEl) {
        let nextSlideStatus = nextItem.StatusName;
        TweenLite.fromTo(slideStatusEl, 0.5, {
          autoAlpha: 1,
          y: 0
        }, {
          autoAlpha: 0,
          y: 20,
          ease: "Expo.easeIn",
          onComplete: () => {
            this.htmlText.StatusName = nextSlideStatus;
            TweenLite.to(slideStatusEl, 0.5, {
              autoAlpha: 1,
              y: 0,
              delay: 0.1
            });
          }
        });
      }
    },
    /**
     * @description: 鼠标点击按钮
     * @param {*} index
     * @return {*}
     */
    buttonEvents(index) {
      if (!this.AnimatingLook) {
        this.curIdx = index;
        this.AnimatingLook = true;
        this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
        this.mat.uniforms.nextImage.needsUpdate = true;
        this.TweenLiteAnimation();
      }
    },
    // 移动端触摸事件
    touchstartEvents(event) {
      this.startY = event.touches[0].clientY;
    },
    touchendEvents(event) {
      //点击事件直接返回
      if (this.startY == event.changedTouches[0].clientY) {
        return;
      }
      let currentSlideIndex = 0;
      if (!this.AnimatingLook) {
        this.AnimatingLook = true;
        let endY;
        let direction = endY < this.startY ? -1 : 1;
        currentSlideIndex = this.curIdx;
        currentSlideIndex += direction;
        if (currentSlideIndex < 0) {
          currentSlideIndex = this.datatext.length - 1;
        } else if (currentSlideIndex >= this.datatext.length) {
          currentSlideIndex = 0;
        }
        this.curIdx = currentSlideIndex;
        this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
        this.mat.uniforms.nextImage.needsUpdate = true;
        this.TweenLiteAnimation();
      }
    },
    /**
     * @description: 鼠标滚轮事件
     * @return {*}
     */
    addWheelEvents() {
      let currentSlideIndex = 0;
      this.$refs.contentgrid.addEventListener("wheel", event => {
        if (!this.AnimatingLook) {
          this.AnimatingLook = true;
          let direction = event.deltaY < 0 ? -1 : 1;
          currentSlideIndex = this.curIdx;
          currentSlideIndex += direction;
          if (currentSlideIndex < 0) {
            currentSlideIndex = this.datatext.length - 1;
          } else if (currentSlideIndex >= this.datatext.length) {
            currentSlideIndex = 0;
          }
          this.curIdx = currentSlideIndex;
          this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
          this.mat.uniforms.nextImage.needsUpdate = true;
          this.TweenLiteAnimation();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "contentgrid",
    class: _vm.loading && _vm.loadingLook ? 'loading body' : 'body',
    on: {
      "touchstart": function ($event) {
        return _vm.touchstartEvents($event);
      },
      "touchend": function ($event) {
        return _vm.touchendEvents($event);
      }
    }
  }, [_c('main', [_c('div', {
    ref: "slider",
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider-inner"
  }, [_c('div', {
    staticClass: "slider-content"
  }, [_vm._t("slidetitle", null, {
    "htmlText": _vm.htmlText
  }), _vm._v(" "), _vm._t("slidestatus", null, {
    "htmlText": _vm.htmlText
  })], 2)]), _vm._v(" "), _vm._l(_vm.datatext, function (item) {
    return _c('img', {
      key: item.id,
      attrs: {
        "src": item.image
      }
    });
  }), _vm._v(" "), _vm.pagination ? _c('div', {
    staticClass: "pagination"
  }, _vm._l(_vm.datatext.length, function (item, index) {
    return _c('button', {
      key: index,
      class: _vm.curIdx == index ? 'active' : '',
      on: {
        "click": function ($event) {
          return _vm.buttonEvents(index);
        }
      }
    });
  }), 0) : _vm._e()], 2)])]);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-c794f6a6_0", {
    source: "@import url(https://use.typekit.net/euz1eqv.css);a[data-v-c794f6a6]:focus{outline:thin dotted}a[data-v-c794f6a6]:active,a[data-v-c794f6a6]:hover{outline:0}h1[data-v-c794f6a6]{font-size:2em;margin:.67em 0}hr[data-v-c794f6a6]{box-sizing:content-box;height:0}q[data-v-c794f6a6]{quotes:\"“\" \"”\" \"‘\" \"’\"}img[data-v-c794f6a6]{border:0}button[data-v-c794f6a6],input[data-v-c794f6a6],select[data-v-c794f6a6],textarea[data-v-c794f6a6]{font-family:inherit;font-size:100%;margin:0}button[data-v-c794f6a6],input[data-v-c794f6a6]{line-height:normal}button[data-v-c794f6a6],select[data-v-c794f6a6]{text-transform:none}button[data-v-c794f6a6],html input[type=button][data-v-c794f6a6],input[type=reset][data-v-c794f6a6],input[type=submit][data-v-c794f6a6]{-webkit-appearance:button;cursor:pointer}button[disabled][data-v-c794f6a6],html input[disabled][data-v-c794f6a6]{cursor:default}button[data-v-c794f6a6]::-moz-focus-inner,input[data-v-c794f6a6]::-moz-focus-inner{border:0;padding:0}*[data-v-c794f6a6],[data-v-c794f6a6]::after,[data-v-c794f6a6]::before{box-sizing:border-box}.body[data-v-c794f6a6]{width:100%;height:100%;background-color:#23272a;overflow:hidden;margin:0;position:relative}main[data-v-c794f6a6]{position:relative;width:100%;height:100%}.slider[data-v-c794f6a6]{width:100%;max-width:1200px;height:100%;margin:0 auto;position:relative}[data-v-c794f6a6] .slider canvas{width:150%;height:150%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2}.slider img[data-v-c794f6a6]{width:100%;max-width:100%;position:relative;z-index:0}.slider-inner[data-v-c794f6a6]{position:relative;display:flex;align-items:center;width:100%;max-width:1060px;height:100%;margin:0 auto;z-index:5}.slider-content[data-v-c794f6a6]{padding:0 10px}.slider-content h2[data-v-c794f6a6]{font-family:acta-display,serif;font-weight:400;font-size:30px;letter-spacing:-1px;color:#fff;line-height:30px;margin:20px 0 60px}@media screen and (min-width:800px){.slider-content h2[data-v-c794f6a6]{font-size:110px;line-height:100px}}.slider-content span[data-v-c794f6a6]{display:none}.slider-content .meta[data-v-c794f6a6]{display:inline-block;font-family:Arial,sans-serif;font-size:11px;letter-spacing:5px;color:#88888a;text-transform:uppercase;position:relative}@media screen and (min-width:800px){.slider-content .meta[data-v-c794f6a6]{font-size:13px}}.slider-content .meta[data-v-c794f6a6]:after{content:\"\";display:block;position:absolute;top:5px;right:-55px;width:45px;height:2px;background-color:#393d40}.slider-content #slide-status[data-v-c794f6a6]{margin-top:10px;font-family:acta-display,serif;font-weight:400;font-size:18px;color:#fff}@media screen and (min-width:800px){.slider-content #slide-status[data-v-c794f6a6]{font-size:34px}}.pagination[data-v-c794f6a6]{position:absolute;top:50%;transform:translateY(-50%);right:30px;z-index:6}.pagination button[data-v-c794f6a6]{display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;width:16px;height:16px;background-color:#fff;border-radius:100%;padding:0;margin:30px 0;cursor:pointer;position:relative;opacity:.2;transition:opacity .2s ease-in-out;outline:0}.pagination button[data-v-c794f6a6]:hover{opacity:.5}.pagination button.active[data-v-c794f6a6]{opacity:1}.pagination button.active[data-v-c794f6a6]:before{width:300%;height:300%;opacity:1}.pagination button[data-v-c794f6a6]:before{content:\"\";display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;border-radius:100%;border:1px solid rgba(255,255,255,.2);opacity:0;transition:opacity .4s ease-in-out,width .4s ease-in-out,height .4s ease-in-out}.loading[data-v-c794f6a6]:before{content:\"\";position:absolute;z-index:100000;top:0;left:0;width:100%;height:100%;background:#000}.loading[data-v-c794f6a6]:after{content:\"\";position:absolute;z-index:100000;top:50%;left:50%;width:60px;height:60px;margin:-30px 0 0 -30px;pointer-events:none;border-radius:50%;opacity:.4;background:#fff;-webkit-animation:loaderAnim-data-v-c794f6a6 .7s linear infinite alternate forwards;animation:loaderAnim-data-v-c794f6a6 .7s linear infinite alternate forwards}@-webkit-keyframes loaderAnim-data-v-c794f6a6{to{opacity:1;transform:scale3d(.5,.5,1)}}@keyframes loaderAnim-data-v-c794f6a6{to{opacity:1;transform:scale3d(.5,.5,1)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$1 = "data-v-c794f6a6";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);
var Contentgrid = __vue_component__$1;

//
var script = {
  name: "Carousel",
  // vue component name
  props: {
    //接受的数据
    dataArray: {
      type: Array
    },
    //是否显示loading
    loading: {
      type: Boolean,
      default: true
    },
    //是否显示右侧按钮
    pagination: {
      type: Boolean,
      default: true
    },
    //是否自动切换
    autoplay: {
      type: Boolean,
      default: true
    },
    //是否鼠标移上去暂停
    shouldPause: {
      type: Boolean,
      default: false
    },
    //自动切换时间间隔
    interval: {
      type: Number,
      default: 3000
    },
    //动画强度
    intensity: {
      type: Number,
      default: 0.4
    }
  },
  // 使用watch监听
  watch: {
    dataArray: {
      immediate: true,
      deep: true,
      handler(newvalue, oldvalue) {
        //this.headobj =newvalue;不做拷贝不行接受的是地址值
        this.datatext = JSON.parse(JSON.stringify(newvalue));
      }
    }
  },
  data() {
    return {
      render: {
        renderW: 0,
        renderH: 0
      },
      canvasProperty: {
        canvasWidth: 0,
        canvasHeight: 0
      },
      //滚动位移参数
      startX: 0,
      //three属性
      renderer: null,
      scene: null,
      camera: null,
      mat: null,
      //指示当前展示的索引
      curIdx: 0,
      //loading锁
      loadingLook: true,
      //渲染锁
      AnimatingLook: false,
      //渲染的图片组
      sliderImages: [],
      //定时器
      slideshowInterval: null,
      htmlText: {
        TitleName: "远东豹",
        StatusName: "极度濒危"
      }
    };
  },
  created() {
    this.$emit("myEvent");
  },
  methods: {
    init() {
      imagesLoaded(document.querySelectorAll("img"), () => {
        this.loadingLook = false;
        const el = this.$refs.slider;
        const imgs = Array.from(el.querySelectorAll("img"));
        this.displacementSlider({
          parent: el,
          images: imgs
        });
        this.animate();
        this.resize();
      });
    },
    /**
     * @description: 动画渲染
     * @return {*}
     */
    animate() {
      requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
    },
    /**
     * @description: 主方法
     * @param {*} opts
     * @return {*}
     */
    displacementSlider(opts) {
      // 顶点着色器代码
      let vertex = `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
`;
      // 片段着色器代码
      let fragment = `
      varying vec2 vUv;

    uniform sampler2D currentImage;
    uniform sampler2D nextImage;
    uniform float dispFactor;
    void main() {

        vec2 uv = vUv;
        vec4 _currentImage;
        vec4 _nextImage;
        float intensity = ${this.$props.intensity};

        vec4 orig1 = texture2D(currentImage, uv);
        vec4 orig2 = texture2D(nextImage, uv);
        //计算图片x轴位移
        float origPos1 =float(uv.x+(dispFactor * (orig2 * intensity)));
        float origPos2 = float(uv.x -(1.0 - dispFactor) * (orig1 * intensity));
         // 当前图片的偏移
        _currentImage = texture2D(currentImage,vec2(origPos1,uv.y));
        // 下一张图片的偏移
        _nextImage = texture2D(nextImage,vec2(origPos2,uv.y));
    
        // 混合两张图片
        vec4 finalTexture = mix(_currentImage, _nextImage, dispFactor);
      
        gl_FragColor = finalTexture;

    }
`;
      let images = opts.images,
        image;
      this.canvasProperty.canvasWidth = images[0].clientWidth;
      this.canvasProperty.canvasHeight = images[0].clientHeight;
      let parent = opts.parent;
      let renderWidth = parent.offsetWidth;
      let renderHeight = parent.offsetHeight;

      // 按照1:1.2的比例计算宽高
      let aspectRatio = 1.2;
      let minDimension = Math.min(renderWidth, renderHeight);
      let maxDimension = Math.max(renderWidth, renderHeight);
      if (maxDimension === renderWidth) {
        this.render.renderW = minDimension * aspectRatio;
        this.render.renderH = minDimension;
      } else {
        this.render.renderH = minDimension * aspectRatio;
        this.render.renderW = minDimension;
      }

      // 创建 WebGL 渲染器
      let renderer = new THREE.WebGLRenderer({
        antialias: false
      });
      // 设置像素比率

      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setClearColor(0x23272a, 1.0);
      renderer.setSize(this.render.renderW, this.render.renderH);
      parent.appendChild(renderer.domElement);
      // 创建纹理加载器
      let loader = new THREE.TextureLoader();
      loader.crossOrigin = "anonymous";
      //遍历图片列表，将其添加到sliderImages数组中
      images.forEach(img => {
        image = loader.load(img.getAttribute("src") + "?v=" + Date.now());
        image.magFilter = image.minFilter = THREE.LinearFilter;
        image.anisotropy = renderer.capabilities.getMaxAnisotropy();
        this.sliderImages.push(image);
      });
      // 创建场景、相机、材质和几何体，并添加到场景中
      let scene = new THREE.Scene();
      scene.background = new THREE.Color(0x23272a);
      let camera = new THREE.OrthographicCamera(renderWidth / -2, renderWidth / 2, renderHeight / 2, renderHeight / -2, 1, 1000);
      camera.position.z = 1;
      let mat = new THREE.ShaderMaterial({
        uniforms: {
          dispFactor: {
            type: "f",
            value: 0.0
          },
          currentImage: {
            type: "t",
            value: this.sliderImages[0]
          },
          nextImage: {
            type: "t",
            value: this.sliderImages[1]
          }
        },
        vertexShader: vertex,
        fragmentShader: fragment,
        transparent: true,
        opacity: 1.0
      });
      let geometry = new THREE.PlaneBufferGeometry(parent.offsetWidth, parent.offsetHeight, 1);
      let object = new THREE.Mesh(geometry, mat);
      object.position.set(0, 0, 0);
      scene.add(object);
      this.camera = camera;
      this.renderer = renderer;
      this.mat = mat;
      this.scene = scene;
    },
    /**
     * @description: 视窗大小改变时，重新设置渲染器的大小
     * @return {*}
     */
    resize() {
      window.addEventListener("resize", e => {
        let parent = this.$refs.slider;
        let renderWidth = parent.offsetWidth;
        let renderHeight = parent.offsetHeight;

        // 按照1:1.2的比例计算宽高
        let aspectRatio = 1.2;
        let minDimension = Math.min(renderWidth, renderHeight);
        let maxDimension = Math.max(renderWidth, renderHeight);
        if (maxDimension === renderWidth) {
          this.render.renderW = minDimension * aspectRatio;
          this.render.renderH = minDimension;
        } else {
          this.render.renderH = minDimension * aspectRatio;
          this.render.renderW = minDimension;
        }
        this.renderer.setSize(this.render.renderW, this.render.renderH);
      });
    },
    TweenLiteAnimation() {
      //动画切换时执行的回调函数
      this.$emit("change", this.curIdx);
      TweenLite.to(this.mat.uniforms.dispFactor, 1, {
        value: 1,
        ease: "Expo.easeInOut",
        onComplete: () => {
          this.mat.uniforms.currentImage.value = this.sliderImages[this.curIdx];
          this.mat.uniforms.currentImage.needsUpdate = true;
          this.mat.uniforms.dispFactor.value = 0.0;
          this.AnimatingLook = false;
        }
      });
      //给按钮生成动画
      let slideTitleEl = this.$parent.$refs.slidetitle;
      let slideStatusEl = this.$parent.$refs.slidestatus;
      const nextItem = this.datatext[this.curIdx];
      if (slideTitleEl) {
        let nextSlideTitle = nextItem.TitleName;
        TweenLite.fromTo(slideTitleEl, 0.5, {
          autoAlpha: 1,
          y: 0
        }, {
          autoAlpha: 0,
          y: 20,
          ease: "Expo.easeIn",
          onComplete: () => {
            this.htmlText.TitleName = nextSlideTitle;
            TweenLite.to(slideTitleEl, 0.5, {
              autoAlpha: 1,
              y: 0
            });
          }
        });
      }
      if (slideStatusEl) {
        let nextSlideStatus = nextItem.StatusName;
        TweenLite.fromTo(slideStatusEl, 0.5, {
          autoAlpha: 1,
          y: 0
        }, {
          autoAlpha: 0,
          y: 20,
          ease: "Expo.easeIn",
          onComplete: () => {
            this.htmlText.StatusName = nextSlideStatus;
            TweenLite.to(slideStatusEl, 0.5, {
              autoAlpha: 1,
              y: 0,
              delay: 0.1
            });
          }
        });
      }

      //如果自动播放是开启的，定时器也被暂停了，就开启循环播放
      this.$props.autoplay && !this.slideshowInterval ? this.startSlideshow(this.$props.interval) : "";
    },
    /**
     * @description: 暂停循环播放
     * @return {*}
     */
    pauseSlideshow() {
      this.$props.shouldPause ? this.stopSlideshow() : "";
    },
    /**
     * @description: 开启循环播放
     * @return {*}
     */
    startSlideshowAgain() {
      this.$props.shouldPause ? this.startSlideshow(this.$props.interval) : "";
    },
    /**
     * @description: 定时切换函数
     * @param {*} interval 时间毫秒
     * @return {*}
     */
    startSlideshow(interval) {
      this.slideshowInterval = setInterval(() => {
        const nextIdx = (this.curIdx + 1) % this.sliderImages.length;
        if (!this.AnimatingLook) {
          this.curIdx = nextIdx;
          this.AnimatingLook = true;
          this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
          this.mat.uniforms.nextImage.needsUpdate = true;
          this.TweenLiteAnimation();
        }
      }, interval);
    },
    /**
     * @description: 暂停定时切换
     * @return {*}
     */
    stopSlideshow() {
      clearInterval(this.slideshowInterval);
      this.slideshowInterval = null;
    },
    /**
     * @description: 鼠标点击按钮切换图片
     * @param {*} index
     * @return {*}
     */
    buttonEvents(index) {
      if (!this.AnimatingLook) {
        this.stopSlideshow();
        this.curIdx = index;
        this.AnimatingLook = true;
        this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
        this.mat.uniforms.nextImage.needsUpdate = true;
        this.TweenLiteAnimation();
      }
    },
    /**
     * @description: 移动端触摸事件
     * @param {*} event
     * @return {*}
     */
    touchstartEvents(event) {
      this.startX = event.touches[0].clientX;
    },
    touchendEvents(event) {
      //点击事件直接返回
      if (this.startX == event.changedTouches[0].clientX) {
        return;
      }
      let currentSlideIndex = 0;
      if (!this.AnimatingLook) {
        this.stopSlideshow();
        this.AnimatingLook = true;
        let endX = event.changedTouches[0].clientX;
        let direction = endX < this.startX ? -1 : 1;
        currentSlideIndex = this.curIdx;
        currentSlideIndex += direction;
        if (currentSlideIndex < 0) {
          currentSlideIndex = this.datatext.length - 1;
        } else if (currentSlideIndex >= this.datatext.length) {
          currentSlideIndex = 0;
        }
        this.curIdx = currentSlideIndex;
        this.mat.uniforms.nextImage.value = this.sliderImages[this.curIdx];
        this.mat.uniforms.nextImage.needsUpdate = true;
        this.TweenLiteAnimation();
      }
    }
  },
  mounted() {
    this.init();
    this.$props.autoplay ? this.startSlideshow(this.$props.interval) : "";
  },
  beforeDestroy() {
    this.stopSlideshow();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "contentgrid",
    class: _vm.loading && _vm.loadingLook ? 'loading body' : 'body',
    on: {
      "touchstart": function ($event) {
        return _vm.touchstartEvents($event);
      },
      "touchend": function ($event) {
        return _vm.touchendEvents($event);
      },
      "mouseover": _vm.pauseSlideshow,
      "mouseleave": _vm.startSlideshowAgain
    }
  }, [_c('main', [_c('div', {
    ref: "slider",
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider-inner"
  }, [_c('div', {
    staticClass: "slider-content"
  }, [_vm._t("slidetitle", null, {
    "htmlText": _vm.htmlText
  }), _vm._v(" "), _vm._t("slidestatus", null, {
    "htmlText": _vm.htmlText
  })], 2)]), _vm._v(" "), _vm._l(_vm.datatext, function (item) {
    return _c('img', {
      key: item.id,
      attrs: {
        "src": item.image
      }
    });
  }), _vm._v(" "), _vm.pagination ? _c('div', {
    staticClass: "pagination"
  }, _vm._l(_vm.datatext.length, function (item, index) {
    return _c('button', {
      key: index,
      class: _vm.curIdx == index ? 'active' : '',
      on: {
        "click": function ($event) {
          return _vm.buttonEvents(index);
        }
      }
    });
  }), 0) : _vm._e()], 2)])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-00d3e479_0", {
    source: "@import url(https://use.typekit.net/euz1eqv.css);a[data-v-00d3e479]:focus{outline:thin dotted}a[data-v-00d3e479]:active,a[data-v-00d3e479]:hover{outline:0}h1[data-v-00d3e479]{font-size:2em;margin:.67em 0}hr[data-v-00d3e479]{box-sizing:content-box;height:0}q[data-v-00d3e479]{quotes:\"“\" \"”\" \"‘\" \"’\"}img[data-v-00d3e479]{border:0}button[data-v-00d3e479],input[data-v-00d3e479],select[data-v-00d3e479],textarea[data-v-00d3e479]{font-family:inherit;font-size:100%;margin:0}button[data-v-00d3e479],input[data-v-00d3e479]{line-height:normal}button[data-v-00d3e479],select[data-v-00d3e479]{text-transform:none}button[data-v-00d3e479],html input[type=button][data-v-00d3e479],input[type=reset][data-v-00d3e479],input[type=submit][data-v-00d3e479]{-webkit-appearance:button;cursor:pointer}button[disabled][data-v-00d3e479],html input[disabled][data-v-00d3e479]{cursor:default}button[data-v-00d3e479]::-moz-focus-inner,input[data-v-00d3e479]::-moz-focus-inner{border:0;padding:0}*[data-v-00d3e479],[data-v-00d3e479]::after,[data-v-00d3e479]::before{box-sizing:border-box}.body[data-v-00d3e479]{width:100%;height:100%;background-color:#23272a;overflow:hidden;margin:0;position:relative}main[data-v-00d3e479]{position:relative;width:100%;height:100%}.slider[data-v-00d3e479]{width:100%;max-width:1200px;height:100%;margin:0 auto;position:relative}[data-v-00d3e479] .slider canvas{width:150%;height:150%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2}.slider img[data-v-00d3e479]{width:100%;max-width:100%;position:relative;z-index:0}.slider-inner[data-v-00d3e479]{position:relative;display:flex;align-items:center;width:100%;max-width:1060px;height:100%;margin:0 auto;z-index:5}.slider-content[data-v-00d3e479]{padding:0 10px}.slider-content h2[data-v-00d3e479]{font-family:acta-display,serif;font-weight:400;font-size:30px;letter-spacing:-1px;color:#fff;line-height:30px;margin:20px 0 60px}@media screen and (min-width:800px){.slider-content h2[data-v-00d3e479]{font-size:110px;line-height:100px}}.slider-content span[data-v-00d3e479]{display:none}.slider-content .meta[data-v-00d3e479]{display:inline-block;font-family:Arial,sans-serif;font-size:11px;letter-spacing:5px;color:#88888a;text-transform:uppercase;position:relative}@media screen and (min-width:800px){.slider-content .meta[data-v-00d3e479]{font-size:13px}}.slider-content .meta[data-v-00d3e479]:after{content:\"\";display:block;position:absolute;top:5px;right:-55px;width:45px;height:2px;background-color:#393d40}.slider-content #slide-status[data-v-00d3e479]{margin-top:10px;font-family:acta-display,serif;font-weight:400;font-size:18px;color:#fff}@media screen and (min-width:800px){.slider-content #slide-status[data-v-00d3e479]{font-size:34px}}.pagination[data-v-00d3e479]{position:absolute;left:50%;transform:translateX(-50%);bottom:40px;z-index:6;display:flex}.pagination button[data-v-00d3e479]{display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;width:16px;height:16px;background-color:#fff;border-radius:100%;padding:0;margin:0 30px;cursor:pointer;position:relative;opacity:.2;transition:opacity .2s ease-in-out;outline:0}.pagination button[data-v-00d3e479]:hover{opacity:.5}.pagination button.active[data-v-00d3e479]{opacity:1}.pagination button.active[data-v-00d3e479]:before{width:300%;height:300%;opacity:1}.pagination button[data-v-00d3e479]:before{content:\"\";display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;border-radius:100%;border:1px solid rgba(255,255,255,.2);opacity:0;transition:opacity .4s ease-in-out,width .4s ease-in-out,height .4s ease-in-out}.loading[data-v-00d3e479]:before{content:\"\";position:absolute;z-index:100000;top:0;left:0;width:100%;height:100%;background:#000}.loading[data-v-00d3e479]:after{content:\"\";position:absolute;z-index:100000;top:50%;left:50%;width:60px;height:60px;margin:-30px 0 0 -30px;pointer-events:none;border-radius:50%;opacity:.4;background:#fff;-webkit-animation:loaderAnim-data-v-00d3e479 .7s linear infinite alternate forwards;animation:loaderAnim-data-v-00d3e479 .7s linear infinite alternate forwards}@-webkit-keyframes loaderAnim-data-v-00d3e479{to{opacity:1;transform:scale3d(.5,.5,1)}}@keyframes loaderAnim-data-v-00d3e479{to{opacity:1;transform:scale3d(.5,.5,1)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-00d3e479";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Carousel = __vue_component__;

// Import vue component

// Default export is installable instance of component.
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),
var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = {
    Contentgrid,
    Carousel
  };

  // Attach install function executed by Vue.use()
  installable.install = Vue => {
    Vue.component('Contentgrid', Contentgrid);
    Vue.component('Carousel', Carousel);
  };
  return installable;
})();
// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { Carousel, Contentgrid, entry_esm as default };



//////////////////
// WEBPACK FOOTER
// ./node_modules/contentgrid/dist/contentgrid.esm.js
// module id = null
// module chunks = 